import React, { useState } from 'react';
import './styles.css';
import Demographics from './Demographics';
import UserRole from './UserRole';
// import Step3Preferences from './Step3Preferences';
// import Step4Confirmation from './Step4Confirmation';
import { useSignUpContext } from '../../../context/signup/signupcontext';
import EmailPassword from './EmailPassword';
import { useAuth } from 'context/auth/authcontext';

const SignUpForm: React.FC = () => {
  const { formData } = useSignUpContext(); // Global state for form data
  const [currentStep, setCurrentStep] = useState(1); // Track the current form step
  const { registerUser } = useAuth();

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const prevStep = () => setCurrentStep((prev) => prev - 1);

  const submit = async () => {
    const maniUser = {
      Email: formData.creds.email,
      Password: formData.creds.password,
      BusinessName: formData.demographics.companyName,
      PhoneNumber: formData.demographics.phoneNumber,
      FirstName: formData.demographics.firstName,
      LastName: formData.demographics.lastName,
      Bio: 'landlord',
    };

    console.log('in parent component manipulated data', maniUser);

    try {
      await registerUser(maniUser); // Call the registerUser function from context
      // Handle successful registration (e.g., redirect, clear form, etc.)
    } catch (error: any) {
      alert(error.message);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className='form-container'>
            <Demographics nextStep={nextStep} />
          </div>
        );
      case 2:
        return (
          <div className='form-container'>
            <UserRole nextStep={nextStep} prevStep={prevStep} />
          </div>
        );
      case 3:
        return (
          <div className='form-container'>
            <EmailPassword prevStep={prevStep} submit={submit} />
          </div>
        );
      //   case 4:
      //     return <Step4Confirmation prevStep={prevStep} />;
      default:
        return <Demographics nextStep={nextStep} />;
    }
  };

  return <div className='sign-up-container'>{renderStep()}</div>;
};

export default SignUpForm;
